export const USERS_LIST_DEFAULT_PAGE_SIZE = 25;
export const USERS_LIST_LIMITED_PAGE_SIZE = 5;
